import { ItemLayout, StatusLabel, TradersIcon } from '@/shared/components'
import { ColumnDef } from '@tanstack/react-table'
import { ReferralModel } from '@/entities/referral'
import { getReferralStatusInfo } from '@/entities/referral'

export const teamleadsColumns: ColumnDef<ReferralModel>[] = [
  {
    id: 'expand',
    accessorKey: 'expand',
    header: '',
    cell: () => null,
    enableSorting: false,
    enableHiding: false,
  },
  {
    accessorKey: 'username',
    header: 'Тимлид',
    cell: ({ row }) => {
      const id = row.original.id
      const status = row.original.status
      return (
        <ItemLayout
          icon={<TradersIcon status={status} />}
          title={row.getValue('username')}
          subtitle={id}
        />
      )
    },
  },
  {
    accessorKey: 'status',
    header: 'Статус',
    cell: ({ row }) => {
      const status = row.original.status
      const { title, color } = getReferralStatusInfo(status)
      return <StatusLabel status={color}>{title}</StatusLabel>
    },
  },
  {
    accessorKey: 'dailyLimit',
    header: 'Суточный лимит',
    cell: ({ row }) => <span>{row.getValue('dailyLimit')}</span>,
  },
  {
    accessorKey: 'totalTurnover',
    header: 'Общий оборот',
    cell: ({ row }) => <span>{row.getValue('totalTurnover')}</span>,
  },
  {
    accessorKey: 'personalProfit',
    header: 'Личная прибыль',
    cell: ({ row }) => <span>{row.getValue('personalProfit')}</span>,
  },
  {
    accessorKey: 'conversion',
    header: 'Конверсия',
    cell: ({ row }) => {
      const { percentage, current, goal } = row.original.conversion
      return (
        <span className="flex gap-x-1">
          <span className="font-klein font-medium">{percentage}%</span>
          <span className="text-text-secondary">
            {current}/{goal}
          </span>
        </span>
      )
    },
  },
  {
    accessorKey: 'refPercentage',
    header: 'Реф. процент',
    cell: ({ row }) => <span>{row.getValue('refPercentage')}</span>,
  },
]
